import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Card } from '../ui/Card';
import { RevenueData } from '../../types';

interface RevenueChartProps {
  data: RevenueData[];
  /** Rango de meses mostrado (p. ej. con filtro de período la serie no siempre son 12 barras). */
  subtitle?: string;
}

export const RevenueChart: React.FC<RevenueChartProps> = ({ data, subtitle }) => {
  return (
    <Card title="Ingresos Mensuales">
      {subtitle != null && subtitle !== '' && (
        <p className="text-xs text-gray-500 mb-3">{subtitle}</p>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip
            formatter={(value: number) => [`$${value.toLocaleString()}`, 'Ingresos']}
            contentStyle={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
          />
          <Legend />
          <Bar dataKey="revenue" fill="#FA4999" name="Ingresos" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

